import { render, staticRenderFns } from "./SubmitVecdynData.vue?vue&type=template&id=687534e7&scoped=true&"
import script from "./SubmitVecdynData.vue?vue&type=script&lang=js&"
export * from "./SubmitVecdynData.vue?vue&type=script&lang=js&"
import style0 from "./SubmitVecdynData.vue?vue&type=style&index=0&id=687534e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687534e7",
  null
  
)

export default component.exports